import React, { useState } from 'react';
import { Menu, MenuItem, Sidebar } from 'react-pro-sidebar';
import { useSelector } from 'react-redux';
import { sidebarValidPermission } from 'Util/Permissions';
import IntlMessages from 'Util/IntlMessages';
import SidebarIcon from './SidebarIcon';
import { NavLink, useLocation } from 'react-router-dom';
import NavLinks from './NavLinks';
import FieldAddUpdateDrawer from 'Components/FieldSidebar/components/FieldAddUpdateDrawer';

const SidebarVi = () => {
  const { user } = useSelector(state => state.authUser);
  const { navCollapsed } = useSelector(state => state.settings);
  const { newMenu } = useSelector(state => state.noty);
  const [openFieldPopup, setOpenFieldPopup] = useState(false);
  const { defaultField } = useSelector(state => state.config);

  const location = useLocation();

  const isActive = path => location.pathname.startsWith(path);

  return (
    <>
      <Sidebar
        collapsed={navCollapsed}
        className='main-sidebar'
        style={{
          minWidth: navCollapsed ? '68px' : '185px',
          width: navCollapsed ? '68px' : '185px',
        }}
      >
        <Menu>
          {NavLinks.linksVi
            .filter(menu => sidebarValidPermission(user, menu.path))
            .map(({ menu_title, menu_icon, path, type }, key) => {
              const icon = SidebarIcon().icon.find(x => x.name === menu_icon).icon;
              const actionIcon = SidebarIcon().icon.find(x => x.name === menu_icon).activeIcon;

              const isNew = type && Array.isArray(type) && type.some(key => newMenu?.global?.[key] > 0 || newMenu?.field?.[key] > 0);

              return (
                <MenuItem
                  onClick={e => {
                    if (defaultField?.isFirstField) {
                      e.stopPropagation();
                      e.preventDefault();
                      setOpenFieldPopup(true);
                      return;
                    }
                  }}
                  className={`sidebar-menu-item ${navCollapsed && 'collapsed'} vi`}
                  key={key}
                  icon={<img {...(isActive(path) ? actionIcon : icon)} alt={menu_title} />}
                  component={<NavLink to={path} />}
                >
                  <IntlMessages id={menu_title} />
                  {isNew && <div className='sidebar-menu-item-new' />}
                </MenuItem>
              );
            })}
        </Menu>
      </Sidebar>
      <FieldAddUpdateDrawer
        open={openFieldPopup}
        onClose={() => {
          setOpenFieldPopup(false);
        }}
      />
    </>
  );
};

export default SidebarVi;
